enum DictionariesSelector {
  DisplayName = 'displayName',
  Name = 'name'
}

export default DictionariesSelector;
